import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import InnerPage from '../components/InnerPage.jsx';
import { GALLERY_PHOTOS } from '../data/galleryPhotos.js';
import { withBasePath } from '../utils/paths.js';

export default function GalleryPage() {
  useEffect(() => {
    document.title = 'Gallery | Nouakchott Oumtounsy International Airport (NKC/GQNO)';
  }, []);

  return (
    <InnerPage
      slug="gallery"
      heading="Gallery"
      lead="A look inside Nouakchott Oumtounsy International Airport (NKC/GQNO)."
      banner="/images/airport/airport-terminal-lobby.jpg"
      section="experience"
    >
      <section className="section inner-content">
        <div className="container inner-prose">
          <p className="inner-lead">
            Explore facilities and spaces across the terminal, from check-in and lounges to dining
            and baggage services.
          </p>

          <div className="gallery-grid" role="list">
            {GALLERY_PHOTOS.map((item) => (
              <figure key={item.src} className="gallery-grid__item" role="listitem">
                <img
                  className="gallery-grid__img"
                  src={withBasePath(item.src)}
                  alt={item.caption}
                  width="800"
                  height="600"
                  loading="lazy"
                  decoding="async"
                />
                <figcaption className="gallery-grid__caption">{item.caption}</figcaption>
              </figure>
            ))}
          </div>

          <section className="inner-block" aria-labelledby="gal-more">
            <h2 id="gal-more">Discover Mauritania</h2>
            <ul className="inner-hub-links">
              <li>
                <Link to="/welcome-mauritania">Welcome Mauritania →</Link>
              </li>
              <li>
                <Link to="/experience-mauritania">Experience Mauritania →</Link>
              </li>
              <li>
                <Link to="/sahara-atlantic">Where the Sahara meets the Atlantic →</Link>
              </li>
            </ul>
          </section>

          <p className="inner-disclaimer" role="note">
            Airport and flight information on this website is provided for general guidance only and
            may change without notice. While Nouakchott Oumtounsy International Airport (NKC/GQNO)
            strives to keep content accurate and up to date, information may occasionally be
            incomplete, outdated, or incorrect. Always confirm flight schedules, check-in times,
            baggage allowances, facilities, services, and other travel requirements with your airline
            or the relevant authority before travelling. Entry, visa, customs, and health requirements
            should be verified with the relevant government authorities. Where flight times are shown,
            they are in <abbr title="Greenwich Mean Time">GMT</abbr> (Nouakchott).
          </p>
        </div>
      </section>
    </InnerPage>
  );
}
